import React, { useState, useContext, useEffect } from 'react';
import { Box, Button, IconButton, Tooltip } from '@mui/material';
import SendIcon from '@mui/icons-material/Send';
import { ReactComponent as ExportIcon } from '../../../images/exportIcon.svg';
import CommonAccordion from "../../custom-components/CommonAccordion";
import CommonDownload from '../../custom-components/CommonDownload';
import CodeEditorNew from './BlackScreenNew';
import LikeDislikeComponent from './CommonLikeDislikeComponent';
import { TestCaseFlowDataContext } from '../../main-pages/TestAutomationPage';
import CodeEditor from './CodeEditor';
import { useNavigate, useLocation } from 'react-router-dom';
import { LoadingModalContext } from "../../main-pages/ServicePage";
import { stepDefinitionAPI } from '../../../services/webServices';
import SaveAltRoundedIcon from '@mui/icons-material/SaveAltRounded';
import ThumbDownIcon from '@mui/icons-material/ThumbDown';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import ThumbUpOffAltIcon from "@mui/icons-material/ThumbUpOffAlt";
import ThumbDownOffAltIcon from "@mui/icons-material/ThumbDownOffAlt";
import ThumbUpOutlinedIcon from "@mui/icons-material/ThumbUpOutlined";
import ThumbDownOutlinedIcon from "@mui/icons-material/ThumbDownOutlined";
import ContentCopyOutlinedIcon from "@mui/icons-material/ContentCopyOutlined";
import { ReactComponent as GenerateButton } from "../../../images/generateButton.svg";
import CommonCopy from "../../custom-components/CommonCopy";




const MidLevelKeywords = (props) => {
    const navigate = useNavigate()
    const location = useLocation();
    const [downloadOpen, setDownloadOpen] = useState(false);

    const [midLevelKeywords, setMidLevelKeywords] = useState(props?.midLevelKeywordsData || "");
    console.log(midLevelKeywords)


    const isPageSourceActive = location.state?.showInputForm === true;

    // const pageClass = props.pageClass;
    // const featureFiles = props.featureFile;
    // const [pageClassData, setpageClassData] = useState(props.pageClass);
    const { setLoadingState } = useContext(LoadingModalContext);
    const [liked, setLiked] = useState(false);
    const [disliked, setDisliked] = useState(false);


    const [activeThumb, setActiveThumb] = useState(null);
    const [isCopied, setIsCopied] = useState(false);
    const isButtonEnabled = (
        props.midLevelKeywordsData?.length > 0
    );
    const [keywordBreadCum, setkeywordBreadCum] = useState(props.keywordBreadCum)
    const [projectType, setProjectType] = useState(props.projectType);
    const [pageSource, setPageSource] = useState(false);
    const nextButton = props.midlevelNextButton ? [props.midlevelNextButton] : [];
    const isAccordionOpen = !isPageSourceActive && midLevelKeywords?.length > 0;

    const defaultMidLevelKeyWordExpanded = (Object.keys(props.midLevelKeywordsData).length > 0) && (pageSource);

    // const defaultPageClassExpanded = pageClass !== "" && (location.state?.generatedStepDefinitionData ?? '') === '';

    // useEffect(() => {
    //     if (props.midLevelKeywordsData?.keywordDesignOutputFS) {
    //         setMidLevelOutput(props.midLevelKeywordsData.keywordDesignOutputFS);
    //     }
    // }, [props.midLevelKeywordsData]);

    const handleDownloadClick = () => {
        setDownloadOpen(true);
    };

    const handleCloseDownload = () => {
        setDownloadOpen(false);
    };

    const buttonsgroup = [

        {
            label: "Download",
            variant: "text",
            onClick: handleDownloadClick,
            startIcon: <SaveAltRoundedIcon />,
            // sx: { float: "left" }
        },
        ...nextButton,
    ];
    const handleLike = () => {
        setLiked(!liked);
        if (disliked) setDisliked(false);
    };

    const handleDislike = () => {
        setDisliked(!disliked);
        if (liked) setLiked(false);
    };

    const handleThumbClick = (thumbType) => {
        // Toggle thumbs based on the thumbType (like or dislike)
        setActiveThumb((prev) => (prev === thumbType ? null : thumbType));
    };

    //console.log(midLevelOutput)

    function formatText(text) {
        const lines = text.split("\n").filter(line => line.trim() !== "");
        let formatted = "";
        lines.forEach((line, index) => {
            const trimmedLine = line.trim();

            if (trimmedLine.endsWith(":")) {
                if (index !== 0) {
                    formatted += `\n`;
                }
                formatted += `${trimmedLine}\n`;
            } else {
                if (trimmedLine.startsWith("-")) {
                    formatted += `\t${trimmedLine}\n`;
                } else {
                    formatted += `\t- ${trimmedLine}\n`;
                }
            }
        });

        return formatted.trim();
    }

    return (
        <Box sx={{ maxWidth: 600, margin: 'auto' }}>

            <CommonAccordion
                summary={"Mid-Level Keywords"}
                details={
                    <Box>
                        <CodeEditor codeContent={formatText(midLevelKeywords)} setCodeContent={setMidLevelKeywords} />
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2, marginTop: 2 }}>
                            <Tooltip title="Like" arrow>
                                <Box
                                    onClick={() => handleThumbClick("like")}
                                    sx={{
                                        cursor: "pointer",
                                        marginRight: 2, // Margin between the buttons
                                        "&:hover": {
                                            color: "#49A3FF", // Change color on hover
                                        },
                                    }}
                                >
                                    {activeThumb === "like" ? (
                                        <ThumbUpIcon sx={{ fontSize: "24px" }} /> // Filled thumbs up when clicked
                                    ) : (
                                        <ThumbUpOutlinedIcon sx={{ fontSize: "24px" }} /> // Outlined thumbs up by default
                                    )}
                                </Box>
                            </Tooltip>

                            {/* Thumbs Down Button with Tooltip */}
                            <Tooltip title="Dislike" arrow>
                                <Box
                                    onClick={() => handleThumbClick("dislike")}
                                    sx={{
                                        cursor: "pointer",
                                        marginRight: 2, // Margin between the buttons
                                        "&:hover": {
                                            color: "#FF4842", // Change color on hover
                                        },
                                    }}
                                >
                                    {activeThumb === "dislike" ? (
                                        <ThumbDownIcon sx={{ fontSize: "24px" }} /> // Filled thumbs down when clicked
                                    ) : (
                                        <ThumbDownOutlinedIcon sx={{ fontSize: "24px" }} /> // Outlined thumbs down by default
                                    )}
                                </Box>
                            </Tooltip>

                            <CommonCopy contentToCopy={props.midLevelKeywordsData.keywordDesignOutputFS} />

                            {/* Copy Button with Tooltip */}
                            {/* <Tooltip title={isCopied ? "Copied!" : "Copy"} arrow>
                                <Box
                                    onClick={handleCopyClick}
                                    sx={{
                                        cursor: "pointer",
                                        "&:hover": {
                                            color: "#49A3FF", // Change color on hover
                                        },
                                    }}
                                >
                                    {isCopied ? (
                                        <ContentCopyIcon sx={{ fontSize: "24px" }} /> // Filled copy icon when copied
                                    ) : (
                                        <ContentCopyOutlinedIcon sx={{ fontSize: "24px" }} /> // Outlined copy icon by default
                                    )}
                                </Box>
                            </Tooltip> */}
                        </Box>
                    </Box>
                }
                buttons={buttonsgroup}
                fullScreenMode={true}
                type={"output"}
                defaultExpanded={isAccordionOpen}

            ></CommonAccordion>
            <CommonDownload open={downloadOpen} onClose={handleCloseDownload}
                serviceResponse={[{ heading: "Mid-Level Keywords", type: "text", data: midLevelKeywords }]}
                serviceName="Midlevel-keywords"
                wordData={[{ heading: "Mid-Level Keywords", type: "text", data: midLevelKeywords }]}
                documents={['docx']}

            />

            {/* <CommonDownload open={downloadOpen} onClose={handleCloseDownload} /> */}


        </Box>
    );
};

export default MidLevelKeywords;

